/* eslint-disable react/prop-types */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { usDateFormat } from '../../utils/dateFormat';
const Accordion = ({
  onClick, absenceObj, onChange, onClearSelection,reasons
}) => (
  <div className={(absenceObj.reason === ''
    ? 'accordion-wrapper'
    : 'accordion-wrapper selected-accr')}
  >
    
    <div
      className={absenceObj.isActive
        ? 'accr-date-wrapper active-accr'
        : 'accr-date-wrapper'}
      role="button"
      tabIndex={0}
      onKeyPress={() => onClick(absenceObj.id)}
      onClick={() => onClick(absenceObj.id)}
    >
      <div className="accr-date">
        <span>{usDateFormat(absenceObj.absence_date)}</span>
        <div className="accr-period">
          <span>
            {`(Period : ${absenceObj.period})`}
          </span>
        </div>
      </div>
      <div className="accr-icon">
        {absenceObj.isActive
          ? <FontAwesomeIcon icon={faChevronUp} />
          : <FontAwesomeIcon icon={faChevronDown} /> }

      </div>
    </div>
    {absenceObj.isActive && (
    <div className="accr-content">
      <h6>Please select any reason to Clear Absence. </h6>
      <ul>
        {reasons.map((res) => (
          <li key={res.value}>
            <input
              type="radio"
              id={res.label}
              name="reason"
              value={res.value}
              onChange={(e) => onChange(e, absenceObj.id)}
              required
              checked={(absenceObj.reason === res.value)}
            />
            <label htmlFor={res.label}>
              {res.label}
            </label>
          </li>
        ))}
      </ul>
      <div className="clear-btn-wrapper">
        <button
          type="button"
          className="accr-clear-btn"
          onClick={() => onClearSelection(absenceObj.id)}
        >
          Clear Selection
        </button>
      </div>
    </div>
    )}
  </div>
);

export default Accordion;
